<template>
    <div class="page-card">
        <el-card>
            <el-row :gutter="20">
                <el-col :sm="12" :md="14" :lg="16" :xl="16" class="m-b-10 m-b-md-0">
                    <el-date-picker
                            @change="changeDate"
                            value-format="yyyy-MM-dd HH:mm"
                            format="dd/MM/yyyy HH:mm"
                            class="w-100"
                            v-model="form.Date"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="От"
                            end-placeholder="До"
                            :clearable="false"
                            :picker-options="{ firstDayOfWeek: 1 }"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :sm="12" :md="10" :lg="8" :xl="8" class="d-flex">
                    <el-button :icon="$mobile() ? 'icon-clock' : ''" class="w-50" type="default" @click="handleToday">
                        Сегодня
                    </el-button>
                    <el-button :icon="$mobile() ? 'icon-search' : ''" class="w-50" type="primary" @click="handleFilter">
                        {{ ($mobile() ? 'Обновить данные' : 'Обновить') }}
                    </el-button>
                </el-col>
            </el-row>
        </el-card>

<!--        <report v-if="loaded" name="ArchiveEvents" :form="form" :key="formKey" :autoFetch="autoFetch" />-->
        <report name="ArchiveEvents" :form="form" :key="formKey" :autoFetch="autoFetch" />
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                // loaded: false,
                autoFetch: true,
                form: {
                    Date: [
                        (sessionStorage.getItem('dateFrom') ? sessionStorage.getItem('dateFrom') : Vue.moment().format('YYYY-MM-DD 00:00')),
                        (sessionStorage.getItem('dateTo') ? sessionStorage.getItem('dateTo') : Vue.moment().add(1, 'day').format('YYYY-MM-DD 00:00'))
                    ]
                    // Filter: {
                    //     Type: 'Composite',
                    //     Operation: 'Or',
                    //     Subfilters: []
                    // }
                },
                formKey: 0
            }
        },
        methods: {
            changeDate (date) {
                if (!date) {
                    this.form.Date = this.$today
                    sessionStorage.setItem('dateFrom', this.$today[0])
                    sessionStorage.setItem('dateTo', this.$today[1])
                }
                else {
                    sessionStorage.setItem('dateFrom', date[0])
                    sessionStorage.setItem('dateTo', date[1])
                }
                this.render()
            },
            handleFilter () {
                this.render()
            },
            handleToday () {
                this.form.Date = this.$today
                this.render()
            },
            render () {
                this.formKey += 1
            }
        }
        // created () {
        //     let form = {
        //         SearchString: '',
        //         Page: 1,
        //         PageSize: 20
        //     }
        //
        //     let request = Object.assign({
        //         Name: "GetItemsList",
        //         ItemType: "Card"
        //     }, form)
        //
        //     this.$api.Main.getCards(request).then(response => {
        //         let cards = response.Items
        //         cards.map((card) => {
        //             this.form.Filter.Subfilters.push({
        //                 Type: 'Simple',
        //                 Operation: 'Equal',
        //                 Field: 'CardId',
        //                 Value: card.Name,
        //             })
        //             this.loaded = true
        //         })
        //     }).catch (() => {
        //
        //     })
        // }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
